module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "30%",
      "top": "25vh",
      "center": true,
      "visible": _vm.showDialog,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      },
      "close": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.nuggetLabel) + ":")]), _vm._v("\n      " + _vm._s(_vm.nuggetValue) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('el-button', {
    staticClass: "nugget-control",
    attrs: {
      "size": "small",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.blacklistNugget
    }
  }, [_vm._v("Blacklist for all profiles")]), _vm._v(" "), _c('el-button', {
    staticClass: "nugget-control",
    attrs: {
      "size": "small",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.removeNugget
    }
  }, [_vm._v("Remove from profile")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9928b62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profile/ProfileNuggetOptionsDialog.vue
// module id = 3430
// module chunks = 3